import React, { FC } from 'react';
import MapMarker from 'js/components/MapObjects/MapMarker';
import polygonSvg from 'style/images/drawing/polygon-marker.svg';

interface MarkerData {
  position: google.maps.LatLngLiteral;
}

interface PolygonMarkersProps {
  map: google.maps.Map;
  markers: MarkerData[];
  polygonVisible: boolean;
}

const PolygonMarkers: FC<PolygonMarkersProps> = ({ map, markers, polygonVisible }) => {
  if (polygonVisible || !Array.isArray(markers)) return null;

  const iconOptions: google.maps.Icon = {
    url: polygonSvg,
    scaledSize: new google.maps.Size(20, 20),
    anchor: new google.maps.Point(10, 10),
  };

  return (
    <>
      {markers
        .filter((m) => Boolean(m.position))
        .map((m, idx) => (
          <MapMarker
            key={JSON.stringify(m.position) + idx}
            position={m.position}
            icon={iconOptions}
            map={map}
            clickable={false}
          />
        ))}
    </>
  );
};

export default PolygonMarkers;
